import './index.css'
import {Component} from 'react'
import Cookies from 'js-cookie'
import {Redirect, Link} from 'react-router-dom'
import {formatDistanceToNow} from 'date-fns'
import Loader from 'react-loader-spinner'

import {HiFire} from 'react-icons/hi'
import Header from '../Header'
import ThemeContext from '../ThemeContext'
import LeftPortion from '../LeftPortion'


const apiStatus = {
  initial: 'INITIAL',
  loading: 'LOADING',
  success: 'SUCCESS',
  failure: 'FAILURE',
}

const TrendingVideoCard = ({videoDetails, theme}) => {
  const {id, title, thumbnailUrl, channel, viewCount, publishedAt} =
    videoDetails
  const publishedDate = formatDistanceToNow(new Date(publishedAt))

  return (
    <li className="trending-video-card-list-item">
      <Link to={`/videos/${id}`} className="trending-video-card-link">
        <img
          src={thumbnailUrl}
          className="trending-video-card-thumbnail"
          alt="video thumbnail"
        />
        <div className="trending-video-card-details">
          <p className={`trending-video-card-title ${theme}`}>{title}</p>
          <p className="trending-video-card-channel-name">{channel.name}</p>
          <div className="trending-video-card-stats">
            <p>{viewCount} views</p>
            <p className="dot-separator">•</p>
            <p>{publishedDate} ago</p>
          </div>
        </div>
      </Link>
    </li>
  )
}

class Trending extends Component {
  state = {
    trendingVideos: [],
    fetchStatus: apiStatus.initial,
  }

  componentDidMount() {
    this.fetchTrendingVideos()
  }

  fetchTrendingVideos = async () => {
    this.setState({fetchStatus: apiStatus.loading})
    const apiUrl = `https://apis.ccbp.in/videos/trending`
    const jwtToken = Cookies.get('jwt_token')
    const options = {
      headers: {Authorization: `Bearer ${jwtToken}`},
      method: 'GET',
    }

    try {
      const response = await fetch(apiUrl, options)
      if (response.ok) {
        const data = await response.json()
        const formattedData = data.videos.map(each => ({
          id: each.id,
          title: each.title,
          thumbnailUrl: each.thumbnail_url,
          channel: {name: each.channel.name},
          viewCount: each.view_count,
          publishedAt: each.published_at,
        }))
        this.setState({
          trendingVideos: formattedData,
          fetchStatus: apiStatus.success,
        })
      } else {
        this.setState({fetchStatus: apiStatus.failure})
      }
    } catch (error) {
      this.setState({fetchStatus: apiStatus.failure})
    }
  }

  handleRetry = () => {
    this.fetchTrendingVideos()
  }

  renderLoadingView = () => (
    <div className="view-container" data-testid="loader">
      <Loader type="ThreeDots" color="#4f46e5" height="50" width="50" />
    </div>
  )

  renderFailureView = theme => (
    <div className="view-container">
      <img
        className="failure-image"
        src={
          theme === 'light-theme'
            ? 'https://assets.ccbp.in/frontend/react-js/nxt-watch-failure-view-light-theme-img.png'
            : 'https://assets.ccbp.in/frontend/react-js/nxt-watch-failure-view-dark-theme-img.png'
        }
        alt="failure view"
      />
      <h1>Oops! Something Went Wrong</h1>
      <p>
        We are having some trouble completing your request. Please try again.
      </p>
      <button className="retry-button" type="button" onClick={this.handleRetry}>
        Retry
      </button>
    </div>
  )

  renderSuccessView = theme => {
    const {trendingVideos} = this.state
    return (
      <ul className="trending-videos-list-container">
        {trendingVideos.map(each => (
          <TrendingVideoCard key={each.id} videoDetails={each} theme={theme} />
        ))}
      </ul>
    )
  }

  renderApiStatusView = theme => {
    const {fetchStatus} = this.state
    switch (fetchStatus) {
      case apiStatus.loading:
        return this.renderLoadingView()
      case apiStatus.success:
        return this.renderSuccessView(theme)
      case apiStatus.failure:
        return this.renderFailureView(theme)
      default:
        return null
    }
  }

  render() {
    if (Cookies.get('jwt_token') === undefined) {
      return <Redirect to="/login" />
    }

    return (
      <ThemeContext.Consumer>
        {value => {
          const {activeThemeIsLight} = value
          const theme = activeThemeIsLight ? 'light-theme' : 'dark-theme'

          return (
            <>
              <Header />
              <div className="page-container" data-testid="trending">
                <LeftPortion />
                <div className={`content-container ${theme}`}>
                  <div className="page-header" data-testid="banner">
                    <div className="page-icon-container">
                      <HiFire size={24} color="#ff0000" />
                    </div>
                    <h1>Trending</h1>
                  </div>
                  <div className="content-body">
                    {this.renderApiStatusView(theme)}
                  </div>
                </div>
              </div>
            </>
          )
        }}
      </ThemeContext.Consumer>
    )
  }
}

export default Trending
